import {captureWebsocketError} from '../utils/captureWebsocketError';
import type {SubscriptionState} from './subscriptionTypes';

/**
 * Trips the breaker on a deterministic configuration fault (a missing or
 * malformed `APPSYNC_URL`). Every reconnect would fail identically, so the loop
 * must stop instead of retrying forever.
 *
 * `hasStopped` doubles as the report-once guard: the first call reports to
 * Sentry, every later call is a no-op.
 */
export const stopForMisconfiguration = (reason: string, state: SubscriptionState) => {
  if (state.hasStopped) {
    return;
  }

  state.hasStopped = true;
  clearTimeout(state.reconnectTimer);
  state.reconnectTimer = undefined;

  captureWebsocketError(new Error(reason));
};
